<template>
    <div>

        <vue-headful title="Inspections :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-clipboard"></i> Inspection Forms</li>
                <li class="ml-3">
                    <router-link :to="`/inspections/forms/create`" class="btn btn-sm btn-success" v-if="this.$store.state.user.is_admin"><i class="fa fa-plus-circle"></i> Create</router-link>
                    <router-link :to="`/inspections/forms/import`" class="btn btn-sm btn-info" v-if="this.$store.state.user.is_admin"><i class="fa fa-file-excel-o"></i> Import</router-link>
                </li>
            </ol>
        </h4>

        <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none" v-if="$store.state.user.enable_public_insp_forms">
            <b-nav-item :active="curTab === 'forms'" @click="curTab = 'forms'">
                Forms <span v-if="formCount !== null">({{ formCount }})</span>
            </b-nav-item>
            <b-nav-item :active="curTab === 'public'" @click="curTab = 'public'">
                Public Access Settings
            </b-nav-item>
        </ul>

        <div class="card" v-show="curTab === 'forms'">
            <div class="card-body">
                <v-server-table ref="inspFormsTable" url="/inspections/forms/list" :columns="columns" :options="options">

                    <router-link slot="inspection_form_id" slot-scope="props" :to="`/inspections/forms/view/${props.row.inspection_form_id}`" title="View Form" class="btn btn-sm btn-light">
                        View
                    </router-link>

                    <template slot="is_public_form" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.is_public_form == 1">Yes</label>
                        <label class="badge badge-warning" v-else>No</label>
                    </template>

                    <template slot="is_active" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.is_active == 1">Active</label>
                        <label class="badge badge-warning" v-else>Inactive</label>
                    </template>

                    <template slot="published_at" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.published_at">Published - {{ props.row.published_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}</label>
                        <label class="badge badge-warning" v-else>Draft</label>
                    </template>

                </v-server-table>
            </div>
        </div>

        <template v-if="$store.state.user.enable_public_insp_forms">
            <div class="card" v-show="curTab === 'public'">
                <div class="card-body">
                    <div class="row mb-3">
                        <div class="col-md-3 text-muted text-md-right">Public QR Code:</div>
                        <div class="col-md-5">
                            <qr-code :qr_code_url="`${$root.appUrl}/inspections/public/${client.sds_key}/login`" :qr_code_name="'MeritEHS-INSP-Public-Forms'" :qr_code_size="7" v-if="client.sds_key"></qr-code>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-3 text-muted text-md-right">Public Access URL:</div>
                        <div class="col-md-5">
                            <a :href="`/inspections/public/${client.sds_key}/login`" target="_blank">
                                {{ this.$root.appUrl }}/inspections/public/{{ client.sds_key }}/login
                            </a>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-3 text-muted text-md-right">Require Password for Public Inspections:</div>
                        <div class="col-md-5">
                            <b-form-checkbox v-model="client.req_public_insp_form_password" :value="1" :unchecked-value="0" plain />
                        </div>
                    </div>
                    <div class="row mb-3" v-if="client.req_public_insp_form_password == 1">
                        <div class="col-md-3 text-md-right" :class="{'text-danger': errors.public_insp_form_password, 'text-muted': !errors.public_insp_form_password}">
                            Public Access Password: <i class="fa fa-asterisk text-danger"></i>
                        </div>
                        <div class="col-md-5">
                            <b-form-input v-model="client.public_insp_form_password" placeholder="Enter Public Access Password" :class="{'is-invalid': errors.public_insp_form_password}" />

                            <div v-if="errors.public_insp_form_password" class="text-danger">
                                <ul>
                                    <li v-for="error in errors.public_insp_form_password">{{ error }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 text-muted text-md-right"></div>
                        <div class="col-md-5">
                            <button type="button" class="btn btn-sm btn-success" v-on:click="savePublicAccess()" :disabled="saving">
                                Save Public Access Settings <i class="fa fa-spin fa-spinner" v-show="saving"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            curTab: 'forms',
            formCount: null,
            userTimezone: this.$store.state.user.timezone,
            errors: {},
            saving: false,
            client: {
                sds_key: null,
                req_public_insp_form_password: 0,
                public_insp_form_password: null,
            },
            options: {
                headings: {
                    inspection_form_id: 'ID',
                    form_name: 'Name',
                    total_sections: '# of Sections',
                    total_elements: '# of Elements',
                    total_inspections: '# of Inspections Completed',
                    is_public_form: 'Public',
                    is_active: 'Active',
                    published_at: 'Status',
                },
                orderBy: {
                    ascending: false,
                    column: 'inspectionforms.inspection_form_id',
                },
                uniqueKey: 'inspection_form_id',
                responseAdapter: (response) => {
                    //Emit the count
                    this.formCount = response.data.count;

                    //Send it
                    return response.data;
                },
            },
        }
    },

    computed: {
        columns(){
            //Setup
            if(this.$store.state.user.enable_public_insp_forms == 1)
            {
                //Includes the Public Flag
                return [
                    'inspection_form_id',
                    'form_name',
                    'total_sections',
                    'total_elements',
                    'total_inspections',
                    'is_public_form',
                    'is_active',
                    'published_at',
                ];
            }

            //Default
            return [
                'inspection_form_id',
                'form_name',
                'total_sections',
                'total_elements',
                'total_inspections',
                'is_active',
                'published_at',
            ];
        },
    },

    methods: {
        //get it
        getPublicAccess(){
            //Fetch
            this.$http
                .get('inspections/forms/settings')
                .then(response => {
                    //Set all the data
                    this.client = response.data.client;

                    //Set loading
                    this.loading = false;
                })
                .catch(response => {

                });
        },

        savePublicAccess(){
            //Reset errors
            this.errors = {};

            //Helper
            this.saving = true;

            //Save
            this.$http
                .post('inspections/forms/settings', this.client)
                .then(response => {
                    //Alert the user
                    this.$toastr.success('Public Access Settings Saved');

                    //update the user store?
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.error(error.response.data, 'Failed to Save Public Access Settings');
                    }
                })
                .then(() => {
                    //REset
                    this.saving = false;
                });
        },
    },

    mounted() {
        //Get the inspections
        this.getPublicAccess();
    }
}
</script>
